import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";

export default class PageGuides extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="l-content l-content--fixed-width c-guides">
			    		
			    		<div className="l-grid l-grid--m-even">
			    		
			    			{block.heading &&
				    			
				    			<div className="l-grid__col">
				    				<h2 className='c-heading' dangerouslySetInnerHTML={{__html:block.heading}}></h2>
				    			</div>
				    			
			    			}
							
							{block.cells.map((cell,i) =>
								{
									let gridClass = 'c-guides__cell l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12';

									return (
										<div className={gridClass} key={i}>
											{cell.src && 
												<a href={cell.url} target="blank" className="c-guides__cell__image">
													<FadeIn>
														{onload => (
															<img
																alt={''} 
																src={cell.src} 
																srcSet={cell.srcset} 
																onLoad={onload}
															/>
														)}
													</FadeIn>
												</a>
											}
											<div className="c-guides__cell__text">
												{cell.heading && 
													<h3 className='c-guides__cell__heading' dangerouslySetInnerHTML={{__html:cell.heading}}></h3>
												}
												{cell.text && 
													<div className='c-guides__cell__text scope-text scope-text--faded' dangerouslySetInnerHTML={{__html:cell.text}}></div>
												}
												
											</div>
											{cell.url &&
												<a href={cell.url} target="blank" className="c-guides__cell__link" dangerouslySetInnerHTML={{__html:'<span>&#x2197;&#xFE0E;</span>&nbsp;<span>View more</span>'}}></a>
													
											}
										</div>
									)
								}
							)}
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
